import { createBrowserHistory } from 'history';

// configure, create, and export the project's history instance
const history = createBrowserHistory();
export default history;
